<template>
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="currentColor" d="M8.016 4.736a1.6 1.6 0 0 0-1.623-.03 1.61 1.61 0 0 0-.82 1.403v11.783c0 .583.314 1.119.82 1.403a1.61 1.61 0 0 0 1.623-.03l9.641-5.892a1.608 1.608 0 0 0 0-2.745z"/></svg>
</template>